import { Box, Typography } from '@mui/material';

const SectionTitle = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={{
      mb: 3,
      pb: 1,
      position: 'relative',
      '&:after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '40px',
        height: '3px',
        backgroundColor: '#333',
        borderRadius: '1px',
      },
    }}
  >
    <Typography variant='h6' fontWeight='600' color='text.primary'>
      {children}
    </Typography>
  </Box>
);

export default SectionTitle;
